export const COMPANY_INFO = {
  name: 'Pragyavan Wellness Centre',
  tagline: 'Awareness. Awakened.',
  description: 'Meditation, movement, and mindful living.',
  address: {
    street: 'Near Mangalore International Airport',
    city: 'Mangalore',
    state: 'Karnataka',
    pincode: '574142',
    fullAddress: 'Pragyavan Wellness Centre, Near Mangalore International Airport, Mangalore, Karnataka 574142'
  },
  contact: {
    primary: '+91 8904568399',
    whatsapp: '+91 8904568399',
    email: {
      primary: 'pragyavan2017@gmail.com',
      bookings: 'pragyavan2017@gmail.com',
      info: 'pragyavan2017@gmail.com'
    }
  },
  hours: {
    operation: 'Monday - Sunday: 6:00 AM - 8:00 PM',
    reception: 'Reception: 9:00 AM - 6:00 PM',
    support: '24/7 WhatsApp Support'
  },
  location: {
    coordinates: {
      lat: 12.9485,
      lng: 74.8744
    }
  },
  upi: {
    id: 'pragyavan@hdfcbank'
  }
};

export const NAVIGATION_LINKS = [
  { path: '/', label: 'Home' },
  { path: '/donate', label: 'Donate' },
  { path: '/contact', label: 'Contact' }
];

export const FOOTER_LINKS = {
  services: [
    { label: 'Craniosacral Therapy', path: '/book' },
    { label: 'Guided Meditation', path: '/book' },
    { label: '1:1 Personal Session', path: '/book' }
  ],
  company: [
    { label: 'Events', path: '/events' },
    { label: 'Donate', path: '/donate' },
    { label: 'Contact', path: '/contact' },
    { label: 'Coming Soon', path: '/coming-soon' }
  ],
  support: [
    { label: 'FAQ', path: '#' },
    { label: 'Privacy Policy', path: '#' },
    { label: 'Terms of Service', path: '#' },
    { label: 'Refund Policy', path: '#' }
  ]
};

export const BOOKING_STEPS = [
  { id: 'service', label: 'Select Service', description: 'Choose your wellness service' },
  { id: 'datetime', label: 'Date & Time', description: 'Pick your preferred slot' },
  { id: 'details', label: 'Your Details', description: 'Provide contact information' },
  { id: 'payment', label: 'Payment', description: 'Secure payment processing' },
  { id: 'confirmation', label: 'Confirmation', description: 'Booking confirmed' }
];

export const DONATION_AMOUNTS = [500, 1000, 2500, 5000];

export const SOCIAL_LINKS = [
  { platform: 'facebook', url: '#', icon: 'Facebook' },
  { platform: 'instagram', url: '#', icon: 'Instagram' },
  { platform: 'twitter', url: '#', icon: 'Twitter' },
  { platform: 'youtube', url: '#', icon: 'Youtube' }
];